import type { CardLimits } from '../cards.types';

export const defaultLimitsFixture: CardLimits = {
  daily: {
    atm: { perTransaction: 1000, limit: 2000, used: 998 },
    in_store: { perTransaction: 500, limit: null, used: 0 },
    online: { perTransaction: 500, limit: 5000, used: 5000 },
  },
  monthly: {
    atm: { perTransaction: null, limit: 25000, used: 998 },
    in_store: { perTransaction: null, limit: null, used: 0 },
    online: { perTransaction: null, limit: 15000, used: 15000 },
  },
};

export const LIMITS_SET_BY = 'Anna Smith';
export const LIMITS_SET_AT = '2026-01-12';
